<div class="plugin-form">

  <p class="plugin-section-title">User Account Configuration</p>

  <!-- Cloud Provider selector -->
  <div class="form-label-row">
    <span class="field-label">Cloud Provider</span>
    <mat-icon class="info-icon"
      matTooltip="Select the cloud platform where the user account will be created.">
      info_outline
    </mat-icon>
  </div>
  <div class="provider-grid">
    <div *ngFor="let provider of cloudProviderOptions"
         class="provider-img"
         [class.selected]="selectedCloudProvider === provider.id"
         (click)="selectCloudProvider(provider.id)">
      <img src="../../../../../assets/images/resources/cloudprovider/{{provider.id}}.png"
           [alt]="provider.name" class="provider-thumb">
    </div>
  </div>

  <!-- Access Level -->
  <div class="form-label-row">
    <span class="field-label">Access Level</span>
    <mat-icon class="info-icon"
      matTooltip="Define the level of permissions the user will have.">
      info_outline
    </mat-icon>
  </div>
  <mat-chip-listbox class="access-level-chips">
    <mat-chip-option
      *ngFor="let level of userAccountData.accessLevels"
      [selected]="selectedAccessLevel === level.id"
      (click)="selectAccessLevel(level.id)"
      [matTooltip]="level.name + ' — ' + level.description">
      <mat-icon matChipAvatar>shield</mat-icon>
      {{ level.name }}
    </mat-chip-option>
  </mat-chip-listbox>

</div>
